import type { JSX } from "react";
import { SpiderLoader } from "./SpiderLoader.js";
import { useI18n } from "../i18n/react.js";

/**
 * ⭐ **ROTA YÜKLEYİCİSİ — açılış ekranının devamı.**
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * 🚨 **AYNI BEKLEME, İKİ FARKLI YÜZ.**
 * ═══════════════════════════════════════════════════════════════════════════
 * Kullanıcı uygulamayı açtığında `index.html` içindeki marka işaretini ve
 * sırayla yanan devre düğümlerini görüyor; paket gelip React mount olduktan
 * sonra bir rota parçası indirilirken ise **sol üstte 1em'lik dönen bir daire
 * ve "Yükleniyor…" yazısı** çıkıyordu. Aynı eylem (bekle), iki bambaşka
 * görünüm.
 *
 * Bir arayüzün "derlenmiş" hissetmesi büyük jestlerden değil, **aynı şeyi her
 * yerde aynı biçimde söylemesinden** gelir. Bu bileşen açılış ekranının React
 * tarafındaki karşılığıdır: aynı işaret, aynı hareket, aynı yerleşim.
 *
 * ### ⚠️ Neden `index.html`deki SVG doğrudan kullanılamıyor?
 * O SVG token'lardan önce çizilmek zorunda olduğu için renkleri **sabit
 * kodludur** (bilinçli tek istisna). Burada artık `tokens.css` yüklüdür ve
 * `SpiderMark` marka rampasını doğru okur — kiracı teması da dâhil. İkisini
 * tek dosyada birleştirmek, o istisnayı tüm uygulamaya yaymak olurdu.
 *
 * ### ⚠️ Gecikmeli beliriş burada da geçerlidir
 * Rota parçaları çoğunlukla milisaniyeler içinde gelir. Yükleyicinin bir an
 * görünüp kaybolması, hiç görünmemesinden daha rahatsız edicidir; bu yüzden
 * CSS'te 240 ms gecikmeyle belirir (`[data-route-loader]`).
 */
export function RouteLoader(): JSX.Element {
  const i18n = useI18n();
  return (
    /*
     * ⚠️ `role="status"` + GÖRÜNÜR metin: dönen/yanan bir grafik ekran
     *    okuyucuya hiçbir şey söylemez. Metin görsel kullanıcıdan da
     *    gizlenmez — o da ne beklediğini bilmelidir.
     */
    <main data-route-loader role="status" aria-live="polite">
      <span data-loader-mark aria-hidden="true">
        <SpiderLoader size={72} />
      </span>
      <span>{i18n.t("common.loading")}</span>
    </main>
  );
}
